import { UnitSettings as TcpsUnitSettings } from '../../generated/index';
import { UnitSettings } from '@trimble/types';

export const mapToTcpsModel = (input: UnitSettings): TcpsUnitSettings => ({
  angularunit: input.angularUnit,
  angularunitformat: input.angularUnitFormat,
  areaunit: input.areaUnit,
  areaunitformat: input.areaUnitFormat,
  lengthmeasurementunit: input.lengthMeasurementUnit,
  lengthmeasurementunitformat: input.lengthMeasurementUnitFormat,
  lengthunit: input.lengthUnit,
  lengthunitformat: input.lengthUnitFormat,
  unitsystem: input.unitSystem,
  volumeunit: input.volumeUnit,
  volumeunitformat: input.volumeUnitFormat,
  weightunit: input.weightUnit,
  weightunitformat: input.weightUnitFormat,
});

export const mapToDomain = (input: TcpsUnitSettings): UnitSettings => ({
  angularUnit: input.angularunit,
  angularUnitFormat: input.angularunitformat,
  areaUnit: input.areaunit,
  areaUnitFormat: input.areaunitformat,
  lengthMeasurementUnit: input.lengthmeasurementunit,
  lengthMeasurementUnitFormat: input.lengthmeasurementunitformat,
  lengthUnit: input.lengthunit,
  lengthUnitFormat: input.lengthunitformat,
  unitSystem: input.unitsystem,
  volumeUnit: input.volumeunit,
  volumeUnitFormat: input.volumeunitformat,
  weightUnit: input.weightunit,
  weightUnitFormat: input.weightunitformat,
});
